import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { AttendanceLogModel } from "./attendance-log.model";

export class AttendanceLogResponse extends GlobalResponseObject {
    data?: AttendanceLogModel[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: AttendanceLogModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}